import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services/api.service';
import {environment} from '../../../environments/environment';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import { ApplicationClaimTypes } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ApplicationClaimTypesService{
    constructor(
        private http: HttpClient,
        private apiService: ApiService
    ) { }

   
     /**
    * This method is used to get the search results of Application Claim Types
    * based on the parameters.
    *
    * @param  pageNo  current page number
    * @param  pageSize Number of records per page
    * @param  sortField field needed to sort
    * @param  sortOrder whether the sorting field is ascending or descending
    * @param  appliedFilters appliedFilters
    * @return      json result
    */
      public searchApplicationClaimTypes(pageNo:number,pageSize:number,sortField:string,sortOrder:string,appliedFilters:{field:string,matchMode:string,value:string}[]=[]):Observable<any> {
        return this.apiService.get(`ApplicationClaimTypes/SearchApplicationClaimTypes?pageNo=${pageNo}&pageSize=${pageSize}&sortField=${sortField}&sortOrder=${sortOrder}&appliedFilters=${appliedFilters}`)
      }
  
  
      /**
      * This method is used to get all Application Claim Types records, there is no parameter
      *
      * @return      json result
      */
       public getAllApplicationClaimTypes(applicationClaimTypesSearchParam:IGlobalSearchParam):Observable<any> {
        console.log(applicationClaimTypesSearchParam);
        return this.apiService.post(`ApplicationClaimTypes/SearchApplicationClaimTypes`,applicationClaimTypesSearchParam)
      }
  
      /**
      * This method is used to get individual Application Claim Types record based on the claimTypeId
      *
      * @param  claimTypeId  
      * @return      json result
      */
       public getApplicationClaimTypesById(claimTypeId:number):Observable<any> {
          return this.apiService.get(`ApplicationClaimTypes/${claimTypeId}`)
      }
  
      /**
      * This method is used to post/add new Application Claim Types record
      *
      * @param  ApplicationClaimTypes object which contains the ApplicationClaimTypes record values
      * @return      json result
      */
       public postApplicationClaimTypes(applicationClaimTypes:ApplicationClaimTypes):Observable<any> {
          return this.apiService.post(`ApplicationClaimTypes`, applicationClaimTypes)
      }
  
  
      /**
      * This method is used to update the existing Application Claim Types record
      *
      * @param  claim TypeId 
      * @param  ApplicationClaimTypes object which contains the ApplicationClaimTypes record values
      * @return      json result
      */
       public updateApplicationClaimTypes(claimTypeId:number, applicationClaimTypes:ApplicationClaimTypes):Observable<any> {
          return this.apiService.put(`ApplicationClaimTypes/${claimTypeId}`, applicationClaimTypes)
      }
  
  
      /**
      * This method is used to delete the existing Application Claim Types record
      *
      * @param  claim TypeId
      * @return      json result
      */
       public deleteApplicationClaimTypes(claimTypeId:number):Observable<any> {
          return this.apiService.delete(`ApplicationClaimTypes/${claimTypeId}`)
      }

      public ExportClaimTypesResult(claimTypeSearchParam:IGlobalSearchParam):Observable<any> {
        return this.http.post(`${environment.apiRoot}ApplicationClaimTypes/ExportClaimTypes`, claimTypeSearchParam,
        {  
            responseType: 'blob',
            observe: 'response'
         });
      }
  
}
